/**
 * Initializes the modal functionality.
 * @function modal
 */
function modal() {
	const modalTriggers = document.querySelectorAll('button[data-modal]');
	const modals = document.querySelectorAll('dialog[data-modal]');
	const toast = document.querySelectorAll(
		'.notification-toast, .trigger-spotlight'
	);

	// Make the toast available to prevent animation on page load
	if (toast !== null) {
		for (const element of toast) {
			setTimeout(() => {
				element.classList.add('available');
			}, 500);
		}
	}

	// Add event listeners to modal triggers
	for (const trigger of modalTriggers) {
		trigger.addEventListener('click', () => {
			handleModalTriggerClick(trigger);
		});
	}

	// Add event listeners to modals
	for (const modal of modals) {
		handleModalEvents(modal);
	}
}

/**
 * Handles click event on a modal trigger.
 * @param {HTMLElement} trigger - The element that triggers the modal.
 */
function handleModalTriggerClick(trigger) {
	const target = trigger.dataset.modal;
	const modal = document.querySelector(`dialog[data-modal="${target}"]`);

	if (modal.classList.contains('notification-toast')) {
		modal.show();
	} else {
		modal.showModal();
	}
}

/**
 * Handles events for a modal element.
 * @param {HTMLElement} modal - The modal element.
 */
function handleModalEvents(modal) {
	document.addEventListener('click', (e) => {
		if (modal === e.target) {
			modal.close();
		}
	});

	const closeButton = modal.querySelector('.close');
	if (closeButton) {
		closeButton.addEventListener('click', () => {
			modal.close();
			document.body.classList.remove('modal-open');
		});
	}
}

export { modal };
